import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';

import template from './TimeSlotGroup.html?raw';
import TimeSlot from './TimeSlot';
// NOTE (JS2TS): dropped dead deps dojo/dom-style, dojo/on, dojo/query (imported but unused).

class TimeSlotGroup extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;

    entity: any = null;
    entityId: any = null; // identifier entkoppelt vom entity falls mit unterschiedlichen strukturen gearbeitet wird
    _timeSlots: any = [];

    title = "";
    subTitle = "";

    readOnly = false;

    constructor(args: any) {
        super(...(arguments as unknown as []));
        lang.mixin(this, args);

        this._timeSlots = [];
    }

    showIcon = false;

    setupMapping() { } // dummy. wird im TimeSlotPicker überschrieben
    setupSlotMapping() { } // dummy. wird im TimeSlotPicker überschrieben


    _setReadOnlyAttr(value: any) {
        this.readOnly = value;
    }

    _setShowIconAttr(value: any) {
        this.showIcon = value;
        this.drawContent;
    }

    _onClick_TitleIcon(evt: any) {
        this.emit("click_icon", this)
    }

    addSlot(entity: any) {
        var slot = new TimeSlot({
            entity: entity,
            groupWidget: this
        });

        this._timeSlots.push(slot);

        slot.on("selected", lang.hitch(this, "_onSlotSelected"));
        slot.setupMapping = lang.hitch(slot, this.setupSlotMapping);
        slot.placeAt(this.slotContainerNode);
        slot.startup();

        return slot;
    }

    _onSlotSelected(selectedSlot: any, silent?: any) {

        if (selectedSlot.get("selected") == true) {
            var allSlots = this._timeSlots;

            var selectedSlotPassed = false;
            var slotsBefore = [];
            var slotsAfter = [];
            var selectedSlotsBefore = [];
            var selectedSlotsAfter = [];
            var allSelectedSlots = [];

            allSelectedSlots.push(selectedSlot);

            for (var i = 0; i < allSlots.length; i++) {
                var otherSlot = allSlots[i];
                if (otherSlot == selectedSlot) {
                    selectedSlotPassed = true;
                } else {
                    if (selectedSlotPassed == false) {
                        slotsBefore.push(otherSlot);

                        if (otherSlot.get("selected") == true) {
                            selectedSlotsBefore.push(otherSlot);
                            allSelectedSlots.push(otherSlot);
                        }
                    } else {
                        slotsAfter.push(otherSlot);
                        if (otherSlot.get("selected") == true) {
                            selectedSlotsAfter.push(otherSlot);
                            allSelectedSlots.push(otherSlot);
                        }
                    }
                }

            }

            if (allSelectedSlots.length > 1) {
                var slotsToSelect = [];
                var selectSuccessFul = true;
                if (selectedSlotsBefore.length > 0) {
                    // ==============================================
                    // markierung von links nach rechts >-->
                    // ==============================================
                    console.log("markierung von links nach rechts", slotsBefore, selectedSlot.domNode);
                    var startSelecting = false;

                    for (var i = 0; i < slotsBefore.length; i++) {
                        var slotBefore = slotsBefore[i];

                        if (slotBefore.get("selected") == true) {
                            startSelecting = true;
                        }

                        if (startSelecting == true && slotBefore.get("locked") == true) {
                            selectSuccessFul = false;
                            break;
                        }

                        if (startSelecting == true) {
                            slotsToSelect.push(slotBefore);
                        }
                    }

                } else {
                    // ==============================================
                    // markierung von rechts nach links <--<
                    // ==============================================
                    console.log("markierung von rechts nach links", slotsAfter, selectedSlot.domNode);

                    var startSelecting = true;

                    for (var i = 0; i < slotsAfter.length; i++) {
                        var slotAfter = slotsAfter[i];

                        if (slotAfter != selectedSlot) {

                            if (slotAfter.get("selected") == true) {
                                startSelecting = false;
                                break;
                            }

                            if (startSelecting == true && slotAfter.get("locked") == true) {
                                selectSuccessFul = false;
                                break;
                            }

                            if (startSelecting == true) {
                                slotsToSelect.push(slotAfter);
                            }
                        }
                    }
                }

                if (selectSuccessFul == true) {
                    for (var n = 0; n < slotsToSelect.length; n++) {
                        slotsToSelect[n].set("selected", true);
                    }
                } else {
                    console.log("select not successful", selectedSlot.domNode);
                    selectedSlot.set("selected", false);
                }
            }
        }

        if (typeof (silent) != "undefined") {
         //   return;
        }
        (this as any).emit("selected", selectedSlot, this);
    }

    getSlot(entity: any) {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.entity == entity) {
                return slot;
            }
        }
    }

    getSlotById(entityId: any) {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.entityId == entityId) {
                return slot;
            }
        }
    }

    getSlotByStartDate(slotStartDate: any) {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.startDate.getTime() == slotStartDate.getTime()) {
                return slot;
            }
        }
    }

    getSlotByEndDate(slotEndDate: any) {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.endDate.getTime() == slotEndDate.getTime()) {
                return slot;
            }
        }
    }

    getSlotByStartDateHHmm(hours: any, minutes: any) {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.startDate.getHours() == hours && slot.startDate.getMinutes() == minutes) {
                return slot;
            }
        }
    }

    selectAll() {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.get("selected") === false) {
                slot.set("selected", true);
            }
        }
    }

    unselectAll() {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.get("selected")) {
                slot.set("selected", false);
            }
        }
    }

    _getSelectionAttr() {
        var selectedSlots = [];
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            if (slot.get("selected")) {
                selectedSlots.push(slot);
            }
        }
        return selectedSlots;
    }

    clear() {
        for (var i = 0; i < this._timeSlots.length; i++) {
            var slot = this._timeSlots[i];

            slot.destroy();
        }

        this._timeSlots = [];
        domConstruct.empty(this.slotContainerNode);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.drawContent();
    }

    drawContent() {
        (this as any).setupMapping(this);

        domAttr.set(this.titleNode, "innerHTML", this.title);
        domAttr.set(this.subTitleNode, "innerHTML", this.subTitle);

        if (this.showIcon === true) {
            domClass.remove(this.titleIcon, "w3-hide");
        } else {
            domClass.add(this.titleIcon, "w3-hide");
        }
    }

}
TimeSlotGroup.prototype.declaredClass = 'more.Controls.TimeSlotPicker.TimeSlotGroup';

export default mdsWidget(TimeSlotGroup);
